module.exports = __webpack_public_path__ + "static/img/ME.c7c7f3b1.png";